import VueAsset from './components'
import plugins from './plugins'
import filters from './filters'
import third from './third'
import {
  merge as mergeProfile
} from './profile'
import {
  merge as mergeLibs
} from './libs'
import * as utils from './utils'
import {
  merge as mergeUtilsOptions
} from './utils/options'
import './scss/base.scss'

// if (typeof window !== 'undefined' && window.Vue) {
//   VueAsset.install(window.Vue)
// }

export * from './components'
export {
  utils
}

export default {
  options: {

    // 环境配置
    // false不覆盖
    // 详细配置查看 profile/index.js
    profile: {},

    // 扩展插件库配置
    // false布覆盖
    // 详细配置查看 libs/index.js
    libs: {},

    // 插件安装配置
    // false不安装
    // 详细配置各插件中查看
    plugins: {},

    // 过滤器安装配置
    // false不安装
    filters: {},

    // 组件安装配置
    // false不安装
    // 详细配置各组件中查看
    components: {},

    // 第三方安装配置
    // false不安装
    third: {},

    // 工具类配置项
    // false则不覆盖
    utils: {}
  },
  install(Vue, options = {}) {
    let opts = Object.assign({}, this.options, options)

    if (opts.profile !== false) {
      mergeProfile(opts.profile)
    }

    if (opts.libs !== false) {
      mergeLibs(opts.libs)
    }

    if (opts.plugins !== false) {
      Vue.use(plugins, opts.plugins)
    }

    if (opts.filters !== false) {
      Vue.use(filters, opts.filters)
    }

    if (opts.components !== false) {
      Vue.use(VueAsset, opts.components)
    }

    if (opts.third !== false) {
      Vue.use(third, opts.third)
    }

    if (opts.utils !== false) {
      mergeUtilsOptions(opts.utils)
    }
  }
}



// WEBPACK FOOTER //
// ./src/packages/index.js